<script>
  export let families
  export let toggled = false
  export let alignLeft = true

  const currentFamily = families.find((family) => family.current)

  function toggle() {
    toggled = !toggled
  }
</script>

<nav class="root" class:toggled class:alignLeft>
  <button class="toggle" on:click={toggle}>
    <span class="label">{currentFamily.name}</span>
    <svg class="caret" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <polyline vector-effect="non-scaling-stroke" points="5 18 14 9 5 0" />
    </svg>
  </button>

  <div class="families">
    <ul>
      {#each families as family}
        {#if !family.current}
          <li>
            <a class="family" href={family.url}>{family.name}</a>
          </li>
        {/if}
      {/each}
    </ul>
  </div>
</nav>

<style>
  .root {
    position: relative;

    font-size: inherit;
    line-height: inherit;

    z-index: 3;
  }

  .alignLeft .families {
    left: 0;
    right: auto;
  }

  .toggle {
    background-color: var(--main-color);
    color: var(--main-background-color);

    height: calc(var(--line-height-m) * 1.5);

    border: 1px solid var(--main-color);
    outline: 0;

    border-radius: var(--border-radius);

    padding: 0 0.6em;

    white-space: nowrap;

    cursor: pointer;

    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: stretch;
    align-items: center;
  }

  .families {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;

    background-color: var(--main-color);
    color: var(--main-background-color);

    border: 0;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);

    padding: 0.6em;

    min-width: 100%;
  }

  .toggled .families {
    display: block;
  }

  .toggled .toggle {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 1px solid var(--dimmed-color);
  }

  .toggled .caret {
    transform: rotateZ(-90deg);
  }

  .label {
    margin-right: var(--button-spacing);
    margin-bottom: 1px;
  }

  .caret {
    fill: none;
    stroke: var(--main-background-color);
    height: calc(var(--line-height-m) * 0.6);
    width: calc(var(--line-height-m) * 0.6);
    display: inline-flex;
    transform: rotateZ(90deg);
    transition: transform ease-in-out 0.05s;
  }

  .family {
    color: var(--dimmed-background-color);
    text-decoration: none;
    white-space: nowrap;
  }

  .family:hover {
    color: var(--main-background-color);
  }
</style>
